import React, { useContext } from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CategoryIcon from '../../../../../../../assets/SvgIcons/resources/CategoryMenuIcon.svg';
import subCategoryIcon from '../../../../../../../assets/SvgIcons/resources/subCategory.svg';
import { LanguageContext } from '../../../../../../../libs/Context';
import useContentPermissions from './ContentCards/useContentPermissions';

const AddlistMenu = (props) =>
{
	const { anchorEl, handleClose, setOpenCategory, setCategoryType } = props;
	const navigate = useNavigate();
	const { language } = useContext(LanguageContext);
	const {
		isArticlesEnabled,
		isImagesEnabled,
		isVideosEnabled,
		isDocumentsEnabled,
		isPodcastsEnabled,
		isPlaylistsEnabled,
		isSeasonsEnabled
	} = useContentPermissions();
	const handleNavigate = (path) =>
	{
		navigate(path);
		handleClose();
	};

	// Check if any content type is enabled (for categories/subcategories)
	const hasAnyContentEnabled = isArticlesEnabled || isImagesEnabled || isVideosEnabled ||
		isDocumentsEnabled || isPodcastsEnabled || isPlaylistsEnabled || isSeasonsEnabled;

	const menuItems = [
		{
			icon    : CategoryIcon,
			label   : language?.category,
			onClick : () => { setCategoryType('category'); setOpenCategory(true); handleClose(); },
			enabled : true,
			type    : 'create'
		},
		{
			icon    : subCategoryIcon,
			label   : language?.SubcategoryTxt,
			onClick : () => { setCategoryType('subcategory'); setOpenCategory(true); handleClose(); },
			enabled : true,
			type    : 'create'
		},
		{
			icon    : '/images/icons/ArticleContent.svg',
			label   : language?.article,
			onClick : () => handleNavigate('/businessSettings/content/articleCreation'),
			enabled : isArticlesEnabled,
			type    : 'create'
		},
		{
			icon    : '/images/icons/PodcastContent.svg',
			label   : language?.podcasts,
			onClick : () => handleNavigate('/businessSettings/content/podcast'),
			enabled : isPodcastsEnabled,
			type    : 'create'
		},
		{
			icon    : '/images/icons/PlaylistContent.svg',
			label   : language?.playlist,
			onClick : () => { setCategoryType('playlist'); setOpenCategory(true); handleClose(); },
			enabled : isPlaylistsEnabled,
			type    : 'create'
		},
		{
			icon    : '/images/icons/VideoContent.svg',
			label   : language?.videos,
			onClick : () => handleNavigate('/businessSettings/content/video'),
			enabled : isVideosEnabled,
			type    : 'upload'
		},
		{
			icon    : '/images/icons/DocContent.svg',
			label   : language?.documents,
			onClick : () => handleNavigate('/businessSettings/content/documents'),
			enabled : isDocumentsEnabled,
			type    : 'upload'
		},
		{
			icon    : '/images/icons/ImageContent.svg',
			label   : language?.images,
			onClick : () => handleNavigate('/businessSettings/content/image'),
			enabled : isImagesEnabled,
			type    : 'upload'
		}
	];

	// Filter menu items based on permissions
	const enabledMenuItems = menuItems.filter((item) => item.enabled);

	// Separate enabled items by type
	const createItems = enabledMenuItems.filter((item) => item.type === 'create');
	const uploadItems = enabledMenuItems.filter((item) => item.type === 'upload');

	// Don't render the menu if no items are enabled
	if (enabledMenuItems.length === 0)
	{
		return null;
	}

	return (
		<Menu
			anchorEl={anchorEl}
			open={Boolean(anchorEl)}
			onClose={handleClose}
			MenuListProps={{
				'aria-labelledby' : 'basic-button'
			}}
			sx={{
				'& .MuiMenu-list' : {
					display       : 'flex',
					flexDirection : 'column',
					gap           : 1,
					width         : '200px'
				},
				'& .MuiMenuItem-root' : {
					color      : '#737373',
					fontSize   : 16,
					fontWeight : 400,
					'&:hover'  : {
						color : '#24A4C4'
					}
				}
			}}
		>
			{/* Render Create section only if there are create items */}
			{createItems.length > 0 && (
				<>
					<Box borderBottom={'1px solid rgba(218, 215, 215, 0.5)'}>
						<Typography p={1} fontSize={18} fontWeight={400} color={'#000'}>{language?.create}</Typography>
					</Box>

					{createItems.map((item, index) => (
						<MenuItem
							key={`create-${index}`}
							onClick={item?.onClick}
							sx={{
								'&:hover' : {
									'& .icon' : {
										filter : 'invert(49%) sepia(98%) saturate(365%) hue-rotate(145deg) brightness(93%) contrast(92%)'
									}
								}
							}}
						>
							<ListItemIcon>
								<Box component={'img'} src={item.icon} className='icon' sx={{ height: '22px', width: '22px', objectFit: 'contain' }} />
							</ListItemIcon>
							<ListItemText>{item.label}</ListItemText>
						</MenuItem>
					))}
				</>
			)}

			{/* Render Upload section only if there are upload items */}
			{uploadItems.length > 0 && (
				<>
					<Box borderBottom={'1px solid rgba(218, 215, 215, 0.5)'}>
						<Typography p={1} fontSize={18} fontWeight={400} color={'#000'}>{language?.upload}</Typography>
					</Box>

					{uploadItems.map((item, index) => (
						<MenuItem
							key={`upload-${index}`}
							onClick={item?.onClick}
							sx={{
								'&:hover' : {
									'& .icon' : {
										filter : 'invert(49%) sepia(98%) saturate(365%) hue-rotate(145deg) brightness(93%) contrast(92%)'
									}
								}
							}}
						>
							<ListItemIcon>
								<Box component={'img'} src={item.icon} className='icon' sx={{ height: '22px', width: '22px', objectFit: 'contain' }} />
							</ListItemIcon>
							<ListItemText>{item.label}</ListItemText>
						</MenuItem>
					))}
				</>
			)}
		</Menu>
	);
};

export default AddlistMenu;
